import React, { useState } from "react";
import UIComponent from "components/UiComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { useTranslation } from "react-i18next";
import { Link } from "components/Routing";
import userService from "services/userService";
import evaluationConfig from "../../../moduleConfig";

const RequiredEvaluationContent = ({ data }) => {
  const currentRole = userService.getUserRole();
  const checkReqEvalStatuses = ["START", "EDIT", "DRAFT"];
  const { t } = useTranslation();
  
  return (
    <>
      <div className="modal-title">
        {t("lbl.REQUIRED_EVALUATIONS", "Required Evaluations")}
      </div>
      <div className="modal-description">
        <p>
          {t(
            "lbl.COMPLETE_LINKED_EVALUATIONS_FIRST",
            "The following evaluations need to be completed first:  "
          )}
        </p>
        <div>
          {data.map((evaluation) => (
            <div
              className="required-evaluation-title"
              key={evaluation.USER_FORM_ID}
            >
              {currentRole == "TRAINEE" &&
              checkReqEvalStatuses.includes(evaluation.WORKFLOW_ACTIONS) ? (
                <Link
                  key={evaluation.USER_FORM_ID}
                  to={`/${evaluationConfig.map.EVALUATION_FORM.path}/${evaluation.USER_FORM_ID}`}
                  className="pull-left"
                >
                  <FontAwesomeIcon icon={faEdit} size={"1x"} className="mt-2" />{" "}
                  {evaluation.EVAL_FORM_DESC}
                </Link>
              ) : (
                <div>
                  <FontAwesomeIcon
                    icon={faCheck}
                    size={"1x"}
                    className="mt-2"
                  />{" "}
                  {evaluation.EVAL_FORM_DESC}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const NotAccesibleContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="modal-title">
        {t("lbl.ACCESS_EVALUATION", "Access Evaluation")}
      </div>
      <div className="modal-description">
        <p>
          {t(
            "lbl.YOU_CANNOT_VIEW_THIS_EVALUATION",
            "You cannot view this evaluation!"
          )}
        </p>
      </div>
    </>
  );
};

const ListItemModal = ({ data, open, isLoading, closeModal, type }) => {
  const { t } = useTranslation();
  const [isTabPressed, setTabPressed] = useState(false);

  const close = () => {
    setTabPressed(false);
    closeModal();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      setTabPressed(!isTabPressed);
    }
  };

  return (
    <UIComponent
      id="evaluation-modal"
      component="material-modal"
      className="evaluation-modal"
      open={open}
    >
      {isLoading ? (
        <div className="evaluations-modal-header shadow-depth-1 pt-2 pb-2">
          <div className="col">
            <div className="text-mock__full bg-primary-placeholder shine"></div>

            <div className="text-mock__full bg-primary-placeholder shine"></div>

            <div className="text-mock__full bg-primary-placeholder shine"></div>

            <div className="text-mock__full bg-primary-placeholder shine"></div>

            <div className="text-mock__full bg-primary-placeholder shine"></div>

            <div className="text-mock__full bg-primary-placeholder shine"></div>

            <div className="text-mock__full bg-primary-placeholder shine"></div>
          </div>
        </div>
      ) : (
        <div onKeyDown={handleKeyDown}>
          {type === 'REQUIRED_EVALUATIONS' && data.length > 0 ? <RequiredEvaluationContent data={data} /> : <NotAccesibleContent />}          
          <div className="modal-buttons" >
            <UIComponent
              id="closeModal"
              name="closeModal"
              key="closeModal"
              component="smart-button"
              class={`btn-close ${isTabPressed ? 'focus-border' : ''}`}
              title={t("lbl.CLOSE", "Close")}
              iconComponent={
                <FontAwesomeIcon icon={faWindowClose} size={"1x"} />
              }
              onClick={() => {
                close();
              }}
            >
              {" "}
              {t("lbl.CLOSE", "Close")}{" "}
            </UIComponent>
          </div>
        </div>
      )}
    </UIComponent>
  );
};

export default ListItemModal;
